import { Flame } from "lucide-react";

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-2.5" data-testid="brand-logo">
    <span className="relative flex h-9 w-9 items-center justify-center rounded-full border border-copper/50 bg-coffee">
      <Flame className="h-4 w-4 text-caramel" strokeWidth={2} />
    </span>
    <span className="leading-none">
      <span className="block font-serif text-xl font-black tracking-tight text-cream">
        JH <span className="italic font-normal text-caramel">Brew Bites</span>
      </span>
      {!compact && (
        <span className="mt-1 block text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
          Freshly Brewed
        </span>
      )}
    </span>
  </span>
);
